/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Mobile Nav Bar Tabs.
 */

import {useAuth0} from "@auth0/auth0-react";
import React from "react";
import {MobileNavBarTab} from "./MobileNavBarTab";
import {NavBarTab} from "../desktop/NavBarTab";
import { ROUTES } from "../../../config/routes";
import { releaseAndLogout } from "../../../utils/logout";

export const MobileNavBarTabs = ({handleClick}) => {
    const {
        user,
        isAuthenticated,
        getAccessTokenSilently,
        loginWithRedirect,
        logout,
    } = useAuth0();

    const logoutWithRedirect = () => releaseAndLogout(logout);

    return (
        <div className="MobileNavBar__tabs">

            {isAuthenticated && (
                <>
                    <MobileNavBarTab
                        path={ROUTES.DASHBOARD}
                        label="Dashboard"
                        handleClick={handleClick}
                    />

                    <MobileNavBarTab
                        label="Logout"
                        handleClick={() => logoutWithRedirect()}
                    />
                </>
            )}
        </div>
    );
};
